// src/constants/formConstants.js
export const AVAILABLE_SYMPTOMS = [
    { code: "symptom_shortness_of_breath", name: "Shortness of breath" },
    { code: "symptom_swelling", name: "Swelling" },
    { code: "symptom_weight_gain", name: "Weight gain" },
    { code: "symptom_fatigue", name: "Fatigue" },
    { code: "symptom_chest_pain", name: "Chest pain" },
    { code: "symptom_dizziness", name: "Dizziness" },
    { code: "symptom_persistent_cough", name: "Persistent cough" },
    { code: "symptom_trouble_sleeping", name: "Trouble sleeping" }
  ];
  
  export const GENDER_OPTIONS = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" }
  ];
  
  export const DAYS_OF_WEEK = [
    { value: 'monday', label: 'Monday' },
    { value: 'tuesday', label: 'Tuesday' },
    { value: 'wednesday', label: 'Wednesday' },
    { value: 'thursday', label: 'Thursday' },
    { value: 'friday', label: 'Friday' },
    { value: 'saturday', label: 'Saturday' },
    { value: 'sunday', label: 'Sunday' }
  ];
  
  export const TIME_ZONES = [
    'America/New_York',
    'America/Chicago', 
    'America/Denver',
    'America/Los_Angeles',
    'America/Phoenix',
    'America/Anchorage',
    'Pacific/Honolulu',
    'Europe/London',
    'Europe/Paris',
    'Europe/Berlin',
    'Asia/Tokyo',
    'Asia/Shanghai',
    'Australia/Sydney'
  ];

  export const FREQUENCY_OPTIONS = [
    { value: 'weekly', label: 'Weekly' },
    { value: 'daily', label: 'Daily' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'once', label: 'One-Time Call' },
  ];

  export const INTERVAL_OPTIONS = {
    daily: [
      { value: 1, label: 'Every day' },
      { value: 2, label: 'Every 2 days' },
      { value: 3, label: 'Every 3 days' },
      { value: 4, label: 'Every 4 days' },
    ],
    weekly: [
      { value: 1, label: 'Every week' },
      { value: 2, label: 'Every 2 weeks (biweekly)' },
      { value: 3, label: 'Every 3 weeks' },
      { value: 4, label: 'Every 4 weeks' },
    ],
    monthly: [
      { value: 1, label: 'Every month' },
      { value: 2, label: 'Every 2 months' },
      { value: 3, label: 'Every 3 months' },
      { value: 4, label: 'Every 4 months' },
    ],
  };
  export const DAYS_OF_MONTH = Array.from({ length: 31 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1}`,
  }));